import { Observable, from } from 'rxjs';
import { last, map, switchMap } from 'rxjs/operators';
import { getApps, initializeApp } from 'firebase/app';
import {
  deleteObject,
  getStorage,
  ref,
  uploadBytesResumable,
  type FirebaseStorage,
  type UploadTask,
} from 'firebase/storage';
import {
  fromTask,
  getDownloadURL,
  percentage,
  uploadBytesResumable as rxUploadBytesResumable,
} from 'rxfire/storage';
import { environment } from '../../../environments/environment';

const app = getApps().length ? getApps()[0] : initializeApp(environment.firebase);
const storage: FirebaseStorage = getStorage(app);

export function storageRef(path: string) {
  return ref(storage, path);
}

export function uploadFile(path: string, file: Blob | Uint8Array | ArrayBuffer): UploadTask {
  return uploadBytesResumable(ref(storage, path), file);
}

export function downloadUrl(path: string): Observable<string> {
  return getDownloadURL(ref(storage, path));
}

export function deleteObjectAt(path: string): Observable<void> {
  return from(deleteObject(ref(storage, path)));
}

export function uploadPercentage(task: UploadTask): Observable<number | undefined> {
  return percentage(task).pipe(map((p) => p.progress));
}

export function uploadSnapshots(task: UploadTask): Observable<any> {
  return fromTask(task);
}

export function uploadThenUrl(path: string, file: Blob | Uint8Array | ArrayBuffer): Observable<string> {
  return rxUploadBytesResumable(ref(storage, path), file).pipe(
    last(),
    switchMap(() => downloadUrl(path))
  );
}